module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/info-question-mark.svg";